import React, { useContext } from 'react';
import { AutomationsContex } from '../../../engine/FormBuilderAutomationsEngine';
import ActionEmailTemplateEditorEngine from '../engine/ActionEmailTemplateEditorEngine';
import Select from '../../../engine/SelectEngine';
import useTranslations from '../../../../hooks/useTranslations';
import { Tooltip } from '@material-ui/core';

const SetResponsibleAdminView = props => {
  const { formAdmins } = useContext(AutomationsContex);
  const t = useTranslations();
  return (
    <>
      <Tooltip
        arrow
        title={
          !!!formAdmins.length
            ? t('automaions.wizard.actions.admins.placeholder.disabled')
            : ''
        }
      >
        <span>
          <Select
            variant={props.variant}
            customCSS="margin-left: 0.8rem !important;"
            disabled={!!!formAdmins.length}
            placeholder={t('automaions.wizard.actions.admins.placeholder')}
            value={props.adminValue}
            onChange={value => props.updateRoot({ assigneeId: value })}
            options={formAdmins.map(a => ({
              value: a.user_id,
              text: `${a.info.firstName} ${a.info.lastName}`,
              'data-testid': `select-admin-${a.user_id}`
            }))}
          />
        </span>
      </Tooltip>
      <ActionEmailTemplateEditorEngine
        templateId={props.templateId}
        setTemplateId={props.setTemplateId}
      />
    </>
  );
};

export default SetResponsibleAdminView;
